export default "__VITE_ASSET__DPRaNDkY__"